var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 2.5H4.99984C3.15817 2.5 1.6665 3.99167 1.6665 5.83333V11.6667C1.6665 13.5083 3.15817 15 4.99984 15H6.6665V15.8333C6.6665 16.75 7.4165 17.5 8.33317 17.5H11.6665C12.5832 17.5 13.3332 16.75 13.3332 15.8333V15H14.9998C16.8415 15 18.3332 13.5083 18.3332 11.6667V5.83333C18.3332 3.99167 16.8415 2.5 14.9998 2.5ZM11.6665 15.8333H8.33317V15.0333H11.6665V15.8333ZM3.33317 5.83333C3.33317 4.91667 4.08317 4.16667 4.99984 4.16667H14.9998C15.9165 4.16667 16.6665 4.91667 16.6665 5.83333V10H3.33317V5.83333ZM14.9998 13.3333H4.99984C4.08317 13.3333 3.33317 12.5833 3.33317 11.6667H16.6665C16.6665 12.5833 15.9165 13.3333 14.9998 13.3333Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPosIcon);
export default __webpack_public_path__ + "static/media/newPOSIcon.57b77198830e0f63f491756e90241288.svg";
export { ForwardRef as ReactComponent };